module.exports = __webpack_public_path__ + "img/theme-a.660ae620.png";